import { InstructorResponse } from "../contracts/InstructorResponse";
import { InstructorStatus } from "../enums/InstructorStatus";
import { Instructor } from "../models/Instructor";

/**
 * Maps instructor responses from the API to frontend models.
 */
export class InstructorResponseMapper {
  /**
   * Converts a single InstructorResponse to an Instructor model.
   */
  toInstructor = (resp: InstructorResponse): Instructor => {
    return {
      id: resp.id,
      organizationId: resp.organizationId,
      firstName: resp.firstName,
      lastName: resp.lastName,
      fullName: `${resp.firstName} ${resp.lastName}`.trim(),
      email: resp.email,
      status: resp.status,
      isActive: resp.status === InstructorStatus.Active,
      organizationRole: resp.organizationRole,
      dateCreated: resp.dateCreated,
      dateModified: resp.dateModified,
      licenceNumber: resp.licenceNumber ?? null,
    };
  };

  /**
   * Converts an array of InstructorResponse to Instructor models.
   */
  toInstructors = (responses: InstructorResponse[]): Instructor[] =>
    responses.map(this.toInstructor);
}
